module.exports = __webpack_public_path__ + "static/img/39706ff72788b1000334445f61acdd4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro6.jpg
// module id = Xhep
// module chunks = 1